export default {"src":"/_next/static/media/logo.db5cf0ad.svg","height":80,"width":200};